<template>
  <a-modal
    :visible="showMealDialog"
    width="500px"
    dialogClass="tips_account_dialog"
    :title="false"
    :footer="false"
    :closable="false"
    @cancel="closeDialog"
  >
    <div class="tips_account_header">
      <h3 class="dialog_title" v-text="dialog_title"></h3>
      <i class="iconfont icon-close" @click="closeDialog"></i>
    </div>
    <div class="tips_account_body">
      <div class="tips_body_title" v-text="tips_body_title"></div>
      <div class="tips_body_content" v-text="tips_body_content"></div>
    </div>

    <div class="tips_account_footer">
      <a-button type="primary" v-if="false">马上升级</a-button>
      <a-button type="primary" v-if="false">马上续费</a-button>
      <a-button @click="closeDialog">关闭</a-button>
    </div>
  </a-modal>
</template>
<script>

export default {
  computed: {
    showMealDialog: {
      get() {
        return this.$store.state.showMealDialog;
      },
      set(value) {
        this.$store.commit('handleMealDialogVisible', value);
      }
    }
  },
  data() {
    return {
      dialog_title: '升级会员享更多优惠',
      tips_body_title: '当前版本不支持使用该数据',
      tips_body_content: '如果要使用的话，请升级到更高版本',
      closeBackHome: false
    }
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.showMealDialog = false
    }
  },
}
</script>
<style scoped>
/**
*弹框头部
**/
.tips_account_dialog .tips_account_header {
  width: 100%;
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  color: #fff;
  background-color: #047dff;
}
.tips_account_dialog .tips_account_header .dialog_title {
  font-size: 18px;
  font-weight: 400;
  width: 50%;
  display: inline-block;
  color: #fff;
}
.tips_account_dialog .tips_account_header .iconfont {
  color: #fff;
  font-size: 24px;
  float: right;
  cursor: pointer;
}
/* *
*弹框主体
* */
.tips_account_dialog .tips_account_body {
  height: 136px;
  padding: 30px 30px 0;
  position: relative;
  text-align: center;
}

.tips_account_body a {
  font-size: 14px;
  color: #047dff;
  margin-top: 5px;
}

.tips_account_body .tips_body_title {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 32px;
  font-weight: bold;
  margin-bottom: 5px;
}

.tips_account_body .tips_body_title.org {
  color: #e95b23;
}

.tips_account_body .tips_body_content {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
}

/* *
*弹框底部
* */
.tips_account_dialog .tips_account_footer {
  padding-bottom: 30px;
  display: flex;
  justify-content: center;
}
</style>
<style>
.tips_account_dialog .ant-modal-content {
  border-radius: 0;
}

.tips_account_dialog .ant-modal-body {
  padding: 0;
}
</style>